module.exports = __webpack_public_path__ + "static/media/Itau.fd726c2f.png";